// extracted by mini-css-extract-plugin
export default {"navBar":"styles_navBar__ZbdVr","navLink":"styles_navLink__ntxvt","navText":"styles_navText__1JsVE","joinGroupButton":"styles_joinGroupButton__4KDZb"};